export default __webpack_public_path__ + "static/media/MLH.c84d1ac5.svg";